import { httpUtils } from "src/infra/http/utils";
import { inject, injectable } from "tsyringe";
import { Observable } from "rxjs";
import { autoBind } from "src/shared/decorators/autobind";
import { PaymentsEndpoints } from "src/constants/endpoints";
import { HttpClient } from "src/infra/http/client";
import { replaceString } from "src/libs/replace-string";
import { PgaPolicy } from "src/shared/models"; // be careful of circular dependencies

@injectable()
export class PaymentSummaryRepository {
    constructor(@inject("HttpClient") private http: HttpClient) {}

    @autoBind
    getSummary(userIdentity: string, policy: PgaPolicy): Observable<object> {
        const headers = this.http.httpUtils.getMsBaseHeaders(
            window.userIdentity,
            "MEP"
        );
        const url = replaceString(PaymentsEndpoints.Summary, {
            ":userIdentity": window.userIdentity,
            ":businessLine": "all",
            ":policyId": policy.id,
        });
        return this.http.getJSON<Record<string, any>>(url, {
            isPublicRequest: false,
            params: {
                "system-code": policy.product.systemCode,
            },
            customHeader: {
                ...httpUtils.getBaseHeaders(),
                ...headers,
            },
        });
    }
}
